
export const processUiProperties = data => {
    return {
        ...data,
        uiProperties: JSON.stringify(data.uiProperties)
    };
};